var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"ts"}},[(_vm.list.length > 0)?_c('div',{staticClass:"today-statistics-wrapper"},_vm._l((_vm.list),function(li){return _c('div',{staticClass:"modal"},[_c('span',[_vm._v(_vm._s(li.label))]),_c('span',{staticClass:"orange"},[_vm._v(_vm._s(li.value))])])}),0):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-f1964f2a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/charts/TodayStatistics.vue
// module id = pqDJ
// module chunks = 1